import { ExternalLink } from 'assets/icons';
import EmployeeAvatar from 'components/assign/EmployeeAvatar';
import Button from 'components/button';
import Tag from 'components/crm/ui/Tag';
import useText from 'hooks/useText';

// The line under a link's name. A contact gives its role, its company and how
// to reach it: the task's own for its first contact, its company's for a task
// without links (as before). Another record says what it is.
const detailOf = (link, task, text) => {
  const legacy = !task.links?.length;
  if (link.type === 'contact') {
    const own = link.label === task.contactName;
    return legacy
      ? [task.company?.contactRole, link.sub, task.company?.phone]
      : [own && task.contactRole, link.sub, own && task.contactDetail];
  }
  if (legacy && link.type === 'company') return [task.company?.phone];
  return [text(`linkKind_${link.type}`), link.sub];
};

/**
 * One record a task is linked to: its name, what it is, and the button that
 * opens it (none without `onOpen`). A temp worker not validated says so.
 */
const TaskContactCard = ({ link, task, onOpen }) => {
  const { text } = useText('taskPanel');
  const [firstname, ...rest] = (link.label || '').split(' ');
  return (
    <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-3">
      <EmployeeAvatar employee={{ firstname, lastname: rest.join(' ') }} size={40} />
      <div className="min-w-0 flex-1">
        <p className="flex min-w-0 items-center gap-2">
          <span className="truncate text-sm font-medium text-gray-900">{link.label}</span>
          {link.type === 'tempWorker' && link.validated === false && <Tag tone="orange">{text('linkNotValidated')}</Tag>}
        </p>
        <p className="truncate text-xs text-gray-600">{detailOf(link, task, text).filter(Boolean).join(' · ')}</p>
      </div>
      {onOpen && (
        <Button color="SECONDARY" size="SM" className="shrink-0" onClick={onOpen}>
          <ExternalLink wh={16} color="currentColor" />
          {text('fiche')}
        </Button>
      )}
    </div>
  );
};

export default TaskContactCard;
